import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
const MultipleQuestionButton = ({ onClickFn, text, selected }) => {
    const { t } = useTranslation();
    return (_jsx("button", Object.assign({ "data-testid": 'button--multiple', className: `button--multiple ${selected ? 'button--multiple--selected' : ''}`, onClick: onClickFn }, { children: t(text) })));
};
export default MultipleQuestionButton;
